module.exports = __webpack_public_path__ + "static/media/anage-select-banner-casal-home.b4f566ab.webp";